module.exports = __webpack_public_path__ + "static/profile-a4e26f68ee1b827af5f604147484021c.jpg";